import { combineReducers } from "redux";
import formReqLeaveReducer from "./formReqLeave";
import formReqArrivingLateLeaveEarlyReducer from "./formReqArrivingLateLeaveEarly";
import timeKeepingReducer from "./getTimeKeeping";
import getListArriveLateDetailReducer from "./getArriveLateDetail";
import getReasonArriveLateReducer from "./getReasonArriveLate";
import getReasonLeaveReducer from "./getReasonLeave";
import createReqArriveLateReducer from "./createReqArriveLate";
import getDirectionManagerReducer from "./getDirectionManager";
import getListArriveLateReducer from "./getListArriveLate";
import getListRequestLeaveReducer from "./getListRequestLeave";
import getListArriveLateConfigReducer from "./getListArriveLateConfig";
import getListEmployeeReducer from "./getListEmployee";
import attendanceDetailReducer from "./attendanceDetail";
import getListArriveLateManagerReducer from "./getListArriveLateManager";
import getListRequestLeaveManagerReducer from "./getListRequestLeaveManager";
import deleteRequest from "./deleteRequest";
import requestLeaveDetailReducer from "./getRequestLeaveDetail";
import getPaidLeaveBalanceReducer from "./getPaidLeaveBalance";
import getTimeKeepingSummaryReducer from "./getTimeKeepingSummary";
import handleRequestReducer from "./handleRequest";
import getListRequestLeaveConfigReducer from "./getListRequestLeaveConfig";
import updateReqArriveLateReducer from "./updateReqArriveLate";
import checkIsExitsReqArriveLateReducer from "./checkIsExitsReqArriveLate";
import uploadFileReducer from "./uploadFile";
import createReqLeaveReducer from "./createReqLeave";
import getLeaveManagerReqReducer from "./getLeaveManagerReq";
import checkIsExitsReqLeaveReducer from "./checkIsExitsReqLeave";
import getHolidayReducer from "./getHolidays";
import getListManagerOfDepartment from "./getListManagerOfDepartment";
import getTimekeepingMonthReducer from "./getTimekeepingMonth";
import getListFeedbackReducer from "./getListFeedback";
import getListFeedbackManagerReducer from "./getListFeedbackManager";

import sendFeedbackReducer from "./sendFeedback";
import getConfigMinDateReducer from "./getConfigMinDate";
import formFilterTimeKeepingHRReducer from "./formFilterTimeKeepingHR";
import getListTimeKeepingHRReducer from "./getListTimeKeepingHR";
import getListCategoryOptionReducer from "./getCategoryOption";
import exportTimeKeepingHRReducer from "./exportTimeKeepingHR";
import confirmTimeKeepingMonthReducer from "./confirmTimeKeepingMonth";
import exportTimeKeepingMonthReducer from "./exportTimeKeepingMonth";
import timeKeepingManagerReducer from "./getListTimeKeepingManager";
import formFilterTimeKeepingManagerReducer from "./formFilterTimeKeepingManager";
import confirmTimeKeepingReducer from "./confirmTimeKeeping";
import exportTimeKeepingManagerReducer from "./exportTimeKeepingManager";
import getFeedbackDetailReducer from "./getFeedbackDetail";
import getTimeKeepingManagerDetailReducer from "./getTimeKeepingManagerDetail";
import getRangeTimeKeepingReducer from "./getRangeTimeKeeping";
import getListEmployeeOfManagerReducer from "./getEmployeeOfManager";
import formFilterHrReportReducer from "./formFilterHrReport";
import getHrReportReducer from "./getHrReport";
import exportHrReportReducer from "./exportHrReport";
import getTimeConfirmPeriodReducer from "./getTimeConfirmPeriod";
import formFilterEmployeeLeaveReducer from "./formFilterEmployeeLeave";
import getListEmployeeLeaveRequestReducer from "./getListEmployeeLeaveRequest";
import getListEmployeeArriveLateRequestReducer from "./getListEmployeeArriveLateRequest";
import getListEmployeeFeedbackRequestReducer from "./getListEmployeeFeedbackRequest";
import getEmployeeArriveLateDetailReducer from "./getEmployeeArriveLateDetail";
import getEmployeeLeaveDetailReducer from "./getEmployeeLeaveDetail";
import getEmployeeFeedbackDetailReducer from "./getEmployeeFeedbackDetail";
import checkInOnlineReducer from "./checkInOnline";
import getTimeCheckInOnlineReducer from "./timeCheckInOnline";
import exportEmployeeRequestReducer from "./exportEmployeeRequest";
import cancelRequestReducer from "./cancelRequest";
import importTimeKeepingReducer from "./importTimeKeeping";
import exportTemplateTimeKeepingReducer from "./exportTemplateTimeKeeping";
import earlyRegistrationReducer from "./earlyRegistation";
import updateLeaveMaternityOrderReducer from "./updateLeaveMaternityOrder";
import managerApproveEarlyRegisterReducer from "./getManagerApproveEarlyRegister";
import earlyRegistrationDetailReducer from "./getEarlyRegistrationDetail";
import deleteEarlyRegistrationReducer from "./deleteEarlyRegistration";

const declareLeaveReducer = combineReducers({
  formReqLeave: formReqLeaveReducer,
  formArrivingLate: formReqArrivingLateLeaveEarlyReducer,
  timeKeeping: timeKeepingReducer,
  listArriveLate: getListArriveLateReducer,
  arriveLateDetail: getListArriveLateDetailReducer,
  listReasonArriveLate: getReasonArriveLateReducer,
  listReasonLeave: getReasonLeaveReducer,
  createReqArriveLate: createReqArriveLateReducer,
  directionManager: getDirectionManagerReducer,
  listRequestLeave: getListRequestLeaveReducer,
  listArriveLateConfig: getListArriveLateConfigReducer,
  listEmployee: getListEmployeeReducer,
  attendanceDetail: attendanceDetailReducer,
  listArriveLateManager: getListArriveLateManagerReducer,
  listRequestLeaveManager: getListRequestLeaveManagerReducer,
  deleteRequest: deleteRequest,
  requestLeaveDetail: requestLeaveDetailReducer,
  paidLeaveBalance: getPaidLeaveBalanceReducer,
  timeKeepingSummary: getTimeKeepingSummaryReducer,
  handleRequest: handleRequestReducer,
  listRequestLeaveConfig: getListRequestLeaveConfigReducer,
  updateReqArriveLate: updateReqArriveLateReducer,
  checkIsExitsReqArriveLate: checkIsExitsReqArriveLateReducer,
  uploadFile: uploadFileReducer,
  createReqLeave: createReqLeaveReducer,
  listLeaveManagerReq: getLeaveManagerReqReducer,
  checkIsExitsReqLeave: checkIsExitsReqLeaveReducer,
  getHolidays: getHolidayReducer,
  listManagerOfDepartment: getListManagerOfDepartment,
  getTimekeepingMonth: getTimekeepingMonthReducer,
  getListFeedback: getListFeedbackReducer,
  getListFeedbackManager: getListFeedbackManagerReducer,
  sendFeedback: sendFeedbackReducer,
  configMinDate: getConfigMinDateReducer,
  formFilterTimeKeepingHR: formFilterTimeKeepingHRReducer,
  listTimeKeepingHR: getListTimeKeepingHRReducer,
  categoryOption: getListCategoryOptionReducer,
  exportTimeKeepingHR: exportTimeKeepingHRReducer,
  confirmTimeKeepingMonth: confirmTimeKeepingMonthReducer,
  exportTimeKeepingMonth: exportTimeKeepingMonthReducer,
  timeKeepingManager: timeKeepingManagerReducer,
  formFilterTimeKeepingManager: formFilterTimeKeepingManagerReducer,
  confirmTimeKeeping: confirmTimeKeepingReducer,
  exportTimeKeepingManager: exportTimeKeepingManagerReducer,
  getFeedbackDetail: getFeedbackDetailReducer,
  timeKeepingManagerDetail: getTimeKeepingManagerDetailReducer,
  rangeTimeKeeping: getRangeTimeKeepingReducer,
  listEmployeeOfManager: getListEmployeeOfManagerReducer,
  formFilterHrReport: formFilterHrReportReducer,
  getHrReport: getHrReportReducer,
  exportHrReport: exportHrReportReducer,
  timeConfirmPeriod: getTimeConfirmPeriodReducer,
  formFilterEmployeeLeave: formFilterEmployeeLeaveReducer,
  listEmployeeLeaveRequest: getListEmployeeLeaveRequestReducer,
  listEmployeeArriveLateRequest: getListEmployeeArriveLateRequestReducer,
  listEmployeeFeedbackRequest: getListEmployeeFeedbackRequestReducer,
  employeeArriveLateDetail: getEmployeeArriveLateDetailReducer,
  employeeLeaveDetail: getEmployeeLeaveDetailReducer,
  employeeFeedbackDetail: getEmployeeFeedbackDetailReducer,
  checkInOnline: checkInOnlineReducer,
  timeCheckInOnline: getTimeCheckInOnlineReducer,
  exportEmployeeRequest: exportEmployeeRequestReducer,
  cancelRequest: cancelRequestReducer,
  importTimekeeping: importTimeKeepingReducer,
  exportTemplateTimeKeeping: exportTemplateTimeKeepingReducer,
  earlyRegistration: earlyRegistrationReducer,
  updateLeaveMaternityOrder: updateLeaveMaternityOrderReducer,
  managerApproveEarlyRegister: managerApproveEarlyRegisterReducer,
  deleteEarlyRegistration: deleteEarlyRegistrationReducer,
  earlyRegistrationDetail: earlyRegistrationDetailReducer,
});

export default declareLeaveReducer;
